webpackJsonp([114276838955818,60335399758886],{

/***/ 292:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(553);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(292);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _radium = __webpack_require__(23);
	
	__webpack_require__(656);
	
	__webpack_require__(219);
	
	__webpack_require__(655);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//check bottom comment in https://github.com/gatsbyjs/gatsby/issues/1494 for a hack to support multiple layouts
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Haiku | Create interfaces using design tools, code or both.'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'Where designing is building. Create dynamic, cross-platform UIs using design tools, code, or both. Works with any iOS, Android, or Web codebase.' }),
	      _react2.default.createElement('meta', { property: 'og:title', content: 'Haiku' }),
	      _react2.default.createElement('meta', { property: 'og:description', content: 'Where designing is building. Create dynamic, cross-platform UIs using design tools, code, or both. Works with any iOS, Android, or Web codebase.' }),
	      _react2.default.createElement('meta', { property: 'og:image', content: ("https://www.haiku.ai") + '/img/sum.jpg' }),
	      _react2.default.createElement('meta', { property: 'og:url', content: 'https://www.haiku.ai' }),
	      _react2.default.createElement('meta', { property: 'og:site_name', content: 'Haiku' }),
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	      _react2.default.createElement('meta', { name: 'twitter:site', content: '@HaikuForTeams' }),
	      _react2.default.createElement('meta', { name: 'twitter:image:alt', content: 'Haiku Logo' })
	    ),
	    _react2.default.createElement(
	      _radium.StyleRoot,
	      null,
	      children()
	    )
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.any
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-7981557f6449bc8b47bf.js